import React, { useEffect, useState } from "react";
import TitleBar from "../../partials/content/TitleBar";
import httpService from "../../../services/httpServices/httpServices";
import helpersNumber from "../../../helpers/numbers";
import helpersTime from "../../../helpers/time";
import helperSpinner from "../../../helpers/spinner";
import InfoSiteUserAdvertiser from "./InfoSiteUserAdvertiser";
import AddSiteUserAdvertiser from "./AddSiteUserAdvertiser";
import StateSiteUserAdvertiser from "./StateSiteUserAdvertiser";

export default function AllSiteUserAdvertiser() {
  const [allSiteUserAdvertiser, setAllSiteUserAdvertiser] = useState([]);

  useEffect(() => {
    getAllSiteUserAdvertiser();
  }, []);

  const getAllSiteUserAdvertiser = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const allSiteUserAdvertiser = await sendRequestGetAllSiteUserAdvertiser();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!allSiteUserAdvertiser) {
      return;
    }
    setAllSiteUserAdvertiser(allSiteUserAdvertiser);
  };

  const deleteSiteUserAdvertiser = async (siteUserAdvertiserID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestDeleteSiteUserAdvertiser =
      await sendRequestDeleteSiteUserAdvertiser(siteUserAdvertiserID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestDeleteSiteUserAdvertiser) {
      return;
    }
    getAllSiteUserAdvertiser();
  };

  const sendRequestDeleteSiteUserAdvertiser = async (siteUserAdvertiserID) => {
    const headersRequest = getHeaderRequest();
    try {
      await httpService.deleteRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/site-user-advertiser/" +
          siteUserAdvertiserID,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const sendRequestGetAllSiteUserAdvertiser = async () => {
    const headersRequest = getHeaderRequest();
    let allSiteUserAdvertiser;
    try {
      allSiteUserAdvertiser = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/site-user-advertiser",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allSiteUserAdvertiser.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const hasUserHasOneActiveSiteAdvertiser = () => {
    return allSiteUserAdvertiser.some((siteUserAdvertiser) => {
      if (
        siteUserAdvertiser.state ==
        StateSiteUserAdvertiser.statusSiteUserAdvertiser.CONFIRM
      ) {
        return true;
      }
      return false;
    });
  };

  const showButtonAddSitePublisher = () => {
    if (!hasUserHasOneActiveSiteAdvertiser()) {
      return <></>;
    }

    return (
      <div className="pt-2">
        <a
          className="btn btn-success"
          href={`${process.env.REACT_APP_DOMAIN_PUBLISHER}/site/all`}
          target="_blank"
        >
          <span> لیست سایت نمایش دهنده شما</span>
        </a>
      </div>
    );
  };

  const generateAllSiteUserAdvertiser = () => {
    return (
      <>
        <AddSiteUserAdvertiser
          getAllSiteUserAdvertiser={getAllSiteUserAdvertiser}
        />
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره</td>
                <td>آدرس سایت</td>
                <td>وضعیت</td>
                <td>تاریخ درج</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {allSiteUserAdvertiser.map((siteUserAdvertiser, index) => {
                let classNameBadgeType = "";
                switch (siteUserAdvertiser.state) {
                  case StateSiteUserAdvertiser.statusSiteUserAdvertiser.PENDING:
                    classNameBadgeType = "warning";
                    break;
                  case StateSiteUserAdvertiser.statusSiteUserAdvertiser.CONFIRM:
                    classNameBadgeType = "success";
                    break;
                  case StateSiteUserAdvertiser.statusSiteUserAdvertiser.REJECT:
                    classNameBadgeType = "danger";
                    break;
                }

                return (
                  <tr key={siteUserAdvertiser.id}>
                    <td>{helpersNumber.toPersianNum(index + 1)}</td>
                    <td>{helpersNumber.toPersianNum(siteUserAdvertiser.id)}</td>
                    <td className="text-left">
                      <a href={siteUserAdvertiser.site_url} target="_blank">
                        {siteUserAdvertiser.site_url}
                      </a>
                    </td>
                    <td>
                      <span className={`badge  badge-${classNameBadgeType}`}>
                        {siteUserAdvertiser.state}
                      </span>
                    </td>
                    <td dir="ltr">
                      {helpersNumber.toPersianNum(
                        helpersTime.convertGregorianToJalali(
                          siteUserAdvertiser.created_at.split(" ")[0]
                        ) +
                          " " +
                          siteUserAdvertiser.created_at.split(" ")[1]
                      )}
                    </td>
                    <td>
                      <InfoSiteUserAdvertiser
                        siteUserAdvertiser={siteUserAdvertiser}
                      />
                      <span className="pr-2">
                        <span
                          className="btn btn-danger"
                          onClick={async () => {
                            const result = window.confirm("آیا مطمئن هستید؟");
                            if (!result) {
                              return;
                            }
                            await deleteSiteUserAdvertiser(
                              siteUserAdvertiser.id
                            );
                          }}
                        >
                          حذف
                        </span>
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {showButtonAddSitePublisher()}
      </>
    );
  };

  const generateDoseNotHaveSiteUserAdvertiser = () => {
    return (
      <>
        <div className="d-flex flex-column flex-md-row">
          <div className="text-center text-md-right">
            <img
              class="img-fluid"
              src="/assets/img/do-not-have-website-advertiser.svg"
            />
          </div>
          <div className="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
            <p> شما در حال حاضر هیچ سایت تبلیغ دهنده ندارید :(</p>
            <p>برای شروع کار یک سایت تبلیغ دهنده بسازید.</p>
          </div>
        </div>
        <AddSiteUserAdvertiser
          getAllSiteUserAdvertiser={getAllSiteUserAdvertiser}
        />
      </>
    );
  };

  return (
    <div className="container-fluid pt-3 container-all-site-user-advertiser">
      <div className="row">
        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-lg-12 p-0">
          <TitleBar title="سایت های تبلیغ دهنده" />

          <section className="content pt-5">
            <div className="card">
              <div className="card-body">
                {allSiteUserAdvertiser.length == 0
                  ? generateDoseNotHaveSiteUserAdvertiser()
                  : generateAllSiteUserAdvertiser()}
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
